import { render } from "./BeninPage.vue?vue&type=template&id=7112a894&scoped=true"
import script from "./BeninPage.vue?vue&type=script&lang=js"
export * from "./BeninPage.vue?vue&type=script&lang=js"

import "./BeninPage.vue?vue&type=style&index=0&id=7112a894&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7112a894"]])

export default __exports__